import { BaseService } from "core/services";
import DressingRuleRouteService from "./DressingRuleRouteService";

class DressingRuleService extends BaseService {
    constructor(apiClient) {
        super(apiClient, new DressingRuleRouteService());
    }
}

export default DressingRuleService;
